/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Fresh_Bear_RestInputs */

const en_cool_fresh_bear_rest = /** @type {(inputs: Cool_Fresh_Bear_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro logo position`)
};

const de_cool_fresh_bear_rest = /** @type {(inputs: Cool_Fresh_Bear_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro-Logo Position`)
};

/**
* | output |
* | --- |
* | "Intro logo position" |
*
* @param {Cool_Fresh_Bear_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_fresh_bear_rest = /** @type {((inputs?: Cool_Fresh_Bear_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Fresh_Bear_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_fresh_bear_rest(inputs)
	return de_cool_fresh_bear_rest(inputs)
});